import { apiClient, getApiBase } from './api';

const API = getApiBase();

export function superHeaders() {
  const token = localStorage.getItem('super_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export const superApi = {
  get: (url, config = {}) =>
    apiClient.get(`${API}${url}`, { ...config, headers: { ...superHeaders(), ...config.headers } }),
  post: (url, body, config = {}) =>
    apiClient.post(`${API}${url}`, body, { ...config, headers: { ...superHeaders(), ...config.headers } }),
  put: (url, body, config = {}) =>
    apiClient.put(`${API}${url}`, body, { ...config, headers: { ...superHeaders(), ...config.headers } }),
};

export function formatMxn(amount) {
  const n = Number(amount) || 0;
  return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(n);
}
